var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("This is an about page")]),_c('van-button',{attrs:{"type":"primary"}},[_vm._v(" 主要按钮 ")]),_c('p',[_vm._v(_vm._s(_vm.$t("verify_btn")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }